import { Component, OnInit } from '@angular/core';
import { BehaviorSubject } from 'rxjs';
import { Observable } from 'rxjs';
import { AuthService, IAuthState } from 'src/app/share/services/auth.service';
import { CommonService } from 'src/app/share/services/common.service';
import { map } from 'rxjs/operators';
import { IDataPanelViewModel, IStatViewModel, IViewData } from 'src/app/share/entities/view-model';
import { environment } from 'src/environments/environment';
import { HttpClient } from '@angular/common/http';
import { IActionModel } from 'src/app/share/entities/data-view';
import { IFeedbackResponse } from 'src/app/share/entities/api-response';
import { IFeedbackModel, IActionMethodModel } from 'src/app/share/entities/data-model';
import { IPageDataViewModel } from 'src/app/share/pages/pages';

@Component({
  selector: 'app-rate-issue',
  templateUrl: './rate-issue.component.html',
  styleUrls: ['./rate-issue.component.scss']
})
export class RateIssueComponent implements OnInit {

  constructor(private commonService: CommonService, private authService: AuthService, private http: HttpClient) { }

  vm$: Observable<any>
  fb: IFeedbackModel = {

  };
  
  /**
   * 
   * 
   */
   private rateIssueExecute$(): Observable<IPageDataViewModel> {
    return this.commonService.getData('PageCommand', 'rate.issues', 'page-load').pipe(
      map((v: IViewModelrateIssue) => {
        //if (v.workingText)
        //  return { ...v };

        const ret = { ...v, actionsAllowed: true };
        //console.log(ret.data);
        if (ret.data) {
          // stat panel 
          ret.statPanelVm = ret.data.statPanel ? {
            data: ret.data.statPanel
          } : null;

          // affiliate rates
          ret.affiliateRatePanelVm = ret.data.affiliateRatePanel && !ret.data.affiliateRatePanel.unauthorized ? {
            data: ret.data.affiliateRatePanel,
            rows: ret.data.affiliateRatePanel.rows.map(r => ({ code: r[0], actionTitle: "Send to IT", fields: r })),
            rowsFiltered: ret.data.affiliateRatePanel.rows.map(r => ({ code: r[0], actionTitle: "Send to IT", fields: r })),
            styleTypes: [],
            styleTypesFiltered: [],
            //actions: [
            //  { name: "Ticket", code: "doTicket" },
            //  { name: "Ignore", code: "doIgnore" },
            //  { name: "Validate", code: "doValidate" }
            //]
          } : null;

          // corporation rates
          ret.corporationRatePanelVm = ret.data.corporationRatePanel && !ret.data.corporationRatePanel.unauthorized ? {
            data: ret.data.corporationRatePanel,
            rows: ret.data.corporationRatePanel.rows.map(r => ({ code: r[0], actionTitle: "Send to IT", fields: r })),
            rowsFiltered: ret.data.corporationRatePanel.rows.map(r => ({ code: r[0], actionTitle: "Send to IT", fields: r })),
            styleTypes: [],
            styleTypesFiltered: [],
            //actions: [
             // { name: "Ticket", code: "doTicket" },
            //  { name: "Ignore", code: "doIgnore" },
             // { name: "Validate", code: "doValidate" }
            //]
          } : null;

          // affiliate pricing zones
          ret.affiliatePricingZonesPanelVm = ret.data.affiliatePricingZonesPanel && !ret.data.affiliatePricingZonesPanel.unauthorized ? {
            data: ret.data.affiliatePricingZonesPanel,
            rows: ret.data.affiliatePricingZonesPanel.rows.map(r => ({ code: r[0], actionTitle: "Send to IT", fields: r })),
            rowsFiltered: ret.data.affiliatePricingZonesPanel.rows.map(r => ({ code: r[0], actionTitle: "Send to IT", fields: r })),
            styleTypes: [],
            styleTypesFiltered: [],
            //actions: [
            //  { name: "Ticket", code: "doTicket" },
            //  { name: "Ignore", code: "doIgnore" },
            //  { name: "Validate", code: "doValidate" }
            //]
          } : null;

          // corporation pricing zones
          ret.corporationPricingZonesPanelVm = ret.data.corporationPricingZonesPanel && !ret.data.corporationPricingZonesPanel.unauthorized ? {
            data: ret.data.corporationPricingZonesPanel,
            rows: ret.data.corporationPricingZonesPanel.rows.map(r => ({ code: r[0], actionTitle: "Send to IT", fields: r })),
            rowsFiltered: ret.data.corporationPricingZonesPanel.rows.map(r => ({ code: r[0], actionTitle: "Send to IT", fields: r })),
            styleTypes: [],
            styleTypesFiltered: [],
            actions:[]
            //actions: [
            //  { name: "Ticket", code: "doTicket" },
            //  { name: "Ignore", code: "doIgnore" },
            //  { name: "Validate", code: "doValidate" }
            //]
          } : null;
        }

        return ret;
      })
    );
  }

  ngOnInit() {
    this.vm$ = this.rateIssueExecute$();
  }

  /**
   * 
   */
   refreshPage() {
    this.vm$ = this.rateIssueExecute$();
    this.authService.userInRole;
  }

  /**
   * 
   */
   sendToIT(am: IActionModel) {
     
     this.fb.resNumber = am.code;
     this.fb.subject = "[ECLSweb 2.0 Rate Issue] " + am.section;
     this.fb.userName = am.userName;
     this.fb.addToTrackTable = true;
     
     const s = this.http.post(`${environment.scApiProtocol}://${environment.scApiHost}:${environment.scApiPort}/api/SantaCruz/SubmitFeedback`, this.fb).subscribe(
      (next: IFeedbackResponse) => {
        console.log(next);
        next.success == true ? this.fb.successText = 'Thank You' : this.fb.errorText = next.message;
      },
      (err: any) => {
        console.log(err);
        this.fb.errorText = err.message || err;
        this.fb.workingText = undefined;
      },
      () => {
        s.unsubscribe();
        this.fb.workingText = undefined;
        this.refreshPage();
      });
  }

  /**
   * 
   */
   doAction(action: IActionMethodModel) {
    
 }
}

/**
 * 
 */
 interface IViewModelrateIssue extends IPageDataViewModel {
  data?: { statPanel: any, affiliateRatePanel: IViewData, corporationRatePanel: IViewData, affiliatePricingZonesPanel: IViewData, corporationPricingZonesPanel: IViewData }

  statPanelVm: IStatViewModel;
  affiliateRatePanelVm: IDataPanelViewModel;
  corporationRatePanelVm: IDataPanelViewModel;
  affiliatePricingZonesPanelVm: IDataPanelViewModel;
  corporationPricingZonesPanelVm: IDataPanelViewModel;

  actionsAllowed?: boolean;
}

